import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { ArgoValuesEditor, validateArgoValues } from './ArgoValuesEditor';

/** Campo `ui:field: ArgoValuesEditor` de la plantilla de autoservicio de variables y réplicas. */
export const ArgoValuesEditorExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ArgoValuesEditor',
    component: ArgoValuesEditor,
    validation: validateArgoValues,
  }),
);
